import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Grow from "@material-ui/core/Grow";
import Fade from "@material-ui/core/Fade";
import QuestionAnswerRoundedIcon from "@material-ui/icons/QuestionAnswerRounded";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import "./styles.css";
import {
  WebContext,
  postPrivateApi,
  getDomainValue,
} from "../../../Utility";
import {
  NIGHTCOUNTS,
  HOTELRATINGS_SELECT,
  API_DOMAIN_B2B2C,
  API_SECTION_B2B2C,
  API_ENDPOINT_CHATBOT_LEAD,
  B2B2C_API_PUBLIC_VERSION,
  API_SECTION_UPDATE_FOR_BOT,
} from "../../../Constants";
import  Box  from "@material-ui/core/Box";

const styles = (theme) => ({
  chatBotButton: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(5),
    backgroundColor: theme.palette.primary.main,
    zIndex: 9,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow:
        "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    },
    "& *": {
      color: theme.palette.primary.foreground,
    },
  },
  chatbotContainer: {
    height: "65vh",
    width: "40vw",
    position: "fixed",
    right: theme.spacing(7),
    bottom: theme.spacing(9),
    zIndex:1,
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    transition: "all 0.5s ease",
    [theme.breakpoints.down("sm")]: {
      width: "70vw",
    },
  },
  chatbotContainerHidden: {
    visibility: "hidden",
  },
  chatbotContainerHide: {
    width: "0vw !important",
    height: "0vh !important",
  },
  botHeader: {
    display: "flex",
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1),
    alignItems: "center",
    height: theme.spacing(6),
    "& > p": {
      color: "#ffffff",
    },
    "& > img": {
      height: 50,
      objectFit: "contain",
      marginRight: theme.spacing(1),
    },
    "& > *": {
      color: theme.palette.text.primary,
    },
  },
  formContainer: {
    height: "calc(100% - 50px)",
  },
  opacityNone: {
    opacity: 0,
  },
});

const initialFormData = {
  is_domestic: null,
  is_flight: false,
  destination: "",
  number_of_nights: "",
  date_of_travel: null,
  no_pax: null,
  mobile_number: "",
  name: "",
  hotel_category: "",
  capturing_source: "chatbot",
};

class MyForm extends React.Component {
  static contextType = WebContext;

  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      loading: false,
      formData: initialFormData,
      chatBotCode: "",
    };
    this.cf = null;

    this.submitCallback = this.submitCallback.bind(this);
    this.startBot = this.startBot.bind(this);
    this.toggleFormView = this.toggleFormView.bind(this);
    this.loadBot = this.loadBot.bind(this);
  }

  loadBot() {
    this.setState({ loading: true });

    const script = document.createElement("script");

    script.src =
      "https://cdn.jsdelivr.net/gh/space10-community/conversational-form@1.0.1/dist/conversational-form.min.js";
    script.crossorigin = true;
    script.id = "ConversationalForm";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);

    this.startBot();
  }

  startBot() {
    console.log("start Bot ", window.cf);
    if (window.cf) {
      setTimeout(() => {
        this.setState({ loading: false, showForm: true });
      }, 1000);

      this.cf = window.cf.ConversationalForm.startTheConversation({
        formEl: this.refs.form,
        context: document.getElementById("cf-context"), // <-- bind this to an element instead of html body
        flowStepCallback: (dto, success, error) => {
          console.log(
            "formdata data ",
            dto,
            dto.tag.name,
            dto.tag.value,
            dto.text,
            this.state.formData
          );
          this.updateFormData(dto.tag.name, dto.text);
          success();
        },
        submitCallback: this.submitCallback,
      });
    } else {
      setTimeout(() => {
        this.startBot();
      }, 1000);
    }
  }

  updateFormData = async (type, value) => {
    if (type === "destination-type") {
      type = "is_domestic";
      value = value.toLowerCase().includes("domestic") ? true : false;
    } else if (type === "domestic" || type === "international")
      type = "destination";
    else if (type === "is_flight") {
      value = value.toLowerCase().includes("yes") ? true : false;
    }

    if (!(type in this.state.formData)) return;
    let newState = { ...this.state.formData };
    if (type === "mobile_number") {
      let country_code = (value || []).slice(0, 2);
      let phoneNo = (value || []).slice(2);
      newState["country_code"] = country_code;
      newState["mobile_number"] = phoneNo;
    } else {
      newState[type] = value;
    }
    this.setState({ formData: newState });

    if (type == "mobile_number") {
      this.saveData();
    } else {
      if (!this.state.chatBotCode) return;
      await postPrivateApi(
        `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_CHATBOT_LEAD}${API_SECTION_UPDATE_FOR_BOT}?chatbot_code=${this.state.chatBotCode}`,
        { ...this.state.formData },
        {},
        "patch"
      );
    }
  };

  submitCallback(data) {
    let formDataSerialized = this.cf.getFormData(true);

    console.log(
      "formdata submit ",
      formDataSerialized,
      data,
      this.state.formData
    );

    this.cf.addRobotChatResponse(
      "Thank You For Sharing your number. We will contact you soon."
    );
  }

  saveData() {
    const domainName = getDomainValue(window.location.hostname);
    if (!this.state.formData || !this.state.formData.mobile_number) return;
    postPrivateApi(
      `${API_DOMAIN_B2B2C}${API_SECTION_B2B2C}${B2B2C_API_PUBLIC_VERSION}${API_ENDPOINT_CHATBOT_LEAD}`,
      { ...this.state.formData, domain_name: domainName }
    ).then(({ data = {}, err = null }) => {
      if (err) {
        // TODO: handle error
        console.log("formData save error ", err);
      } else {
        let { chatbot_code = "" } = data;
        this.setState({ chatBotCode: chatbot_code });
        console.log("formData save success ", data, this.state.formData);
      }
    });
  }

  toggleFormView() {
    if (!this.state.showForm) this.loadBot();
    else {
      window.cf = null;
      let rzrPayScript = document.getElementById("ConversationalForm");
      if (rzrPayScript) document.body.removeChild(rzrPayScript);
    }
    this.setState({ showForm: !this.state.showForm });
  }

  render() {
    const { classes } = this.props;
    let { showForm, loading } = this.state;
    const { memberProfile = {}, isMobile = false } = this.context;
    let { account = {} } = memberProfile;
    let { company_name = "" } = account;

    const currentPath = window.location.pathname || "";

    if (isMobile && currentPath.includes("flights")) return null;

    return (
      <div>
        <div>
          <Grow in={true}>
            <Fab
              onClick={() => this.toggleFormView()}
              className={classes.chatBotButton}
            >
              {showForm ? (
                <Fade in={true}>
                  <CloseIcon fontSize="large" />
                </Fade>
              ) : (
                <>
                  {loading ? (
                    <CircularProgress />
                  ) : (
                    <QuestionAnswerRoundedIcon fontSize="large" />
                  )}
                </>
              )}
            </Fab>
          </Grow>
        </div>
        {showForm && (
          <Grow in={showForm}>
            <div
              className={`${classes.chatbotContainer} ${
                !showForm && classes.chatbotContainerHidden
              }`}
            >
              <div p={1} className={classes.botHeader}>
                <Typography variant="body1">{company_name}</Typography>
              </div>
              <div className={classes.formContainer} id="cf-context">
                {this.state.loading && (
                  <Box
                    style={{
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#ffffff",
                    }}
                  >
                    <CircularProgress size={100} />
                  </Box>
                )}
                <div
                  className={`${this.state.loading ? classes.opacityNone : ""}`}
                >
                  <datalist id="destinations">
                    <option value="Bali" />
                    <option value="Dubai" />
                    <option value="Maldives" />
                    <option value="Sri Lanka" />
                    <option value="Europe" />
                    <option value="America" />
                    <option value="Malaysia" />
                    <option value="Thailand" />
                    <option value="Bangkok" />
                    <option value="Goa" />
                    <option value="Char Dham" />
                    <option value="Canada" />
                    <option value="Patayya" />
                    <option value="Bali" />
                    <option value="Dubai" />
                    <option value="Maldives" />
                    <option value="Sri Lanka" />
                    <option value="Europe" />
                    <option value="America" />
                    <option value="Malaysia" />
                    <option value="Thailand" />
                    <option value="Bangkok" />
                    <option value="Goa" />
                    <option value="Char Dham" />
                    <option value="Canada" />
                    <option value="Patayya" />
                  </datalist>
                  <form id="form" className="form" ref="form">
                    <fieldset
                      disabled
                      required
                      qid="introduction"
                      cf-error="This is required"
                      cf-questions="Hello, I am your personal travel consultant"
                    >
                      <input
                        type="tel"
                        cf-error="Please enter a valid phone number with country code"
                        name="mobile_number"
                        pattern="^91[0-9]{10}$"
                        cf-questions="Hello, I am your personal travel consultant. Please can we have your <strong>whatsapp number</strong>? ☎️ (format: 910000000000)"
                        required
                      />
                    </fieldset>
                    <fieldset
                      required
                      qid="destination-type"
                      cf-error="This is required"
                      cf-questions="I can get you best travel deals. Where are you planning to travel. Domestic or International ?"
                    >
                      <input
                        type="radio"
                        name="destination-type"
                        value="domestic"
                        cf-label="Domestic"
                      />
                      <input
                        type="radio"
                        name="destination-type"
                        value="international"
                        cf-label="International"
                      />
                    </fieldset>
                    <fieldset
                      required
                      qid="domestic"
                      name="domestic"
                      cf-error="This is required"
                      cf-questions="Great in India, where are you  planning to travel?"
                    >
                      <input
                        cf-conditional-destination-type="domestic"
                        type="radio"
                        name="domestic"
                        cf-label="Himachal"
                      />
                      <input
                        cf-conditional-destination-type="domestic"
                        type="radio"
                        name="domestic"
                        cf-label="Kerala"
                      />
                      <input
                        cf-conditional-destination-type="domestic"
                        type="radio"
                        name="domestic"
                        cf-label="North East"
                      />
                      <input
                        cf-conditional-destination-type="domestic"
                        type="radio"
                        name="domestic"
                        cf-label="Andaman"
                      />
                      <input
                        cf-conditional-destination-type="domestic"
                        type="radio"
                        name="domestic"
                        cf-label="Kashmir"
                      />
                      <input
                        cf-conditional-destination-type="domestic"
                        type="radio"
                        name="domestic"
                        cf-label="Other"
                      />
                    </fieldset>
                    <fieldset
                      required
                      qid="international"
                      name="international"
                      cf-error="This is required"
                      cf-questions="Ok, great where do you want to go abroad?"
                    >
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Thailand"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Singapore"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Dubai"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Bali"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Europe"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Maldives"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Mauritius"
                      />
                      <input
                        cf-conditional-destination-type="international"
                        type="radio"
                        name="international"
                        cf-label="Others"
                      />
                    </fieldset>
                    <fieldset
                      required
                      qid="number_of_nights"
                      cf-error="This is required"
                      cf-questions="Ok great, how many nights are you planning to travel?"
                    >
                      {NIGHTCOUNTS.map((item, index) => (
                        <input
                          type="radio"
                          name="number_of_nights"
                          value={item.name}
                          cf-label={item.name}
                        />
                      ))}
                    </fieldset>
                    <fieldset
                      qid="is_flight"
                      cf-questions="Ok, sure. we will send a quote, couple of last questions. Do you want flights included?"
                    >
                      <input
                        type="radio"
                        name="is_flight"
                        value="yes"
                        cf-label="Yes, i want flights"
                      />
                      <input
                        type="radio"
                        name="is_flight"
                        value="no"
                        cf-label="No, flights not required"
                      />
                    </fieldset>
                    <input
                      name="date_of_travel"
                      pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/[0-9]{4}$"
                      cf-questions="Please enter your planned date of travel (dd/mm/yyyy)"
                      cf-error="Enter a valid date in dd/mm/yyyy format"
                    />
                    <input
                      type="number"
                      min="1"
                      required
                      cf-error="Must be atleast 1"
                      name="no_pax"
                      cf-questions="How many people will be travelling ?"
                    />
                    <fieldset
                      qid="hotel_category"
                      cf-questions="Lastly, what hotel category option are you looking for?"
                    >
                      {HOTELRATINGS_SELECT.map((item, index) => (
                        <input
                          type="radio"
                          name="hotel_category"
                          value={item.label}
                          cf-label={item.label}
                        />
                      ))}
                    </fieldset>
                    <input
                      type="text"
                      required
                      name="name"
                      ref="name"
                      placeholder="Name"
                      cf-questions="What is your name?"
                    />
                  </form>
                </div>
              </div>
            </div>
          </Grow>
        )}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MyForm);
